import React from 'react'
// import './index.scss'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'horizontal',
      isDefault: true
    },
    'vertical'
  ],
  modifiers: [
    {
      title: 'default',
      isDefault: true
    },
    'primary',
    'inverse'
  ],
  states: []
}
export default function Divider(props) {
  const { dataDivider, inverse, vertical=false, horizontal=false,  primary, ...rest } = props
  return <hr {...rest} className={resolveProps(props, config, 'Divider')} />
}
